// extracted by mini-css-extract-plugin
export default {"spinnerContent":"Spinner_spinnerContent__y1ivd","spinnerButton":"Spinner_spinnerButton__AI7Ad","progress":"Spinner_progress__MatAs"};